export default {
  isOpen: false,
  roomId: undefined,
  startDate: undefined,
  data: undefined,
  type: undefined,
  initial: undefined,
  fields: [],
  errors: undefined,
  loading: false,
  keepRestrictions: undefined,
}
